import {
  CREATE_CONTENT,
  UPDATE_CONTENT_COLLECTION,
  DELETE_CONTENT,
  SET_BOARDS_ORDER,
} from '../actions'
import * as Content from '../reducers/Content'

const createContent = ({ firebase, previousState, nextState }) => {
  const previousIds = Object.keys(previousState.ownContentCollection)
  const nextIds = Object.keys(nextState.ownContentCollection)
  const added = nextIds.filter((id) => !previousIds.includes(id))
  added.forEach((contentId) => {
    const content = nextState.ownContentCollection[contentId]
    firebase.saveContent(content.contentId, content)
  })
}

const deleteContent = ({ firebase, previousState, nextState }) => {
  const previousIds = Object.values(previousState.ownContentCollection).map(
    (item) => item.contentId,
  )
  const nextIds = Object.values(nextState.ownContentCollection).map(
    (item) => item.contentId,
  )
  const removed = previousIds.filter((id) => !nextIds.includes(id))
  removed.forEach((contentId) => {
    firebase.deleteContent(contentId)
  })
}

const setBoardOrder = ({ firebase, nextState }) => {
  firebase.setBoardsOrder(nextState.app.content.order)
}

const updateContentCollection = ({ firebase, previousState, nextState }) => {
  const wasEditing = previousState.app.editing ?? false
  const isEditing = nextState.app.editing ?? false

  if (!isEditing) {
    const previousCollection = previousState.ownContentCollection
    const nextCollection = nextState.ownContentCollection
    // eslint-disable-next-line
    for (const contentId in previousCollection) {
      const previous = previousCollection[contentId]
      // eslint-disable-next-line
      const next = nextCollection[contentId]
      if (
        next !== undefined &&
        (next !== previous ||
          (wasEditing && contentId === previousState.app.selectedContentId))
      ) {
        firebase.saveContent(next.contentId, Content.stripped(next))
      }
    }
  }
}

const firebaseMiddleware = (firebase) => {
  return ({ getState }) => (next) => (action) => {

    const previousState = getState()
    const returnValue = next(action)
    const nextState = getState()

    const parameters = {
      firebase,
      previousState,
      nextState,
    }
    
    switch (action.type) {
      case CREATE_CONTENT:
        createContent(parameters)
        break
      case DELETE_CONTENT:
        deleteContent(parameters)
        break
      case SET_BOARDS_ORDER:
        setBoardOrder(parameters)
        break
      case UPDATE_CONTENT_COLLECTION:
        // avoid call updateContentCollection
        break
      default:
        updateContentCollection(parameters)
    }

    return returnValue
  }
}

export default firebaseMiddleware
